import AuthApi from "../utils/api/AuthApi";
import useAuthToken from "./useAuthToken";
import { update_user_state } from "../state/user_state";
import { useSelector, useDispatch } from "react-redux";
import {useCallback, useMemo} from "react";


const _static_object = {}


export default function useAuthenticatedUser() {
  
  const dispatch = useDispatch();
  const user_data_from_global = useSelector((state) => state.user_state.user_data );
  const {clearToken} = useAuthToken()

  const user_data = useMemo(()=>{
    return user_data_from_global || _static_object
  }, [user_data_from_global])

  const user_id = useMemo(()=>{
    return user_data.id
  }, [user_data])

  const refreshCurrentUser = useCallback( (token) => {
    return new AuthApi(token).get("users/user_informations").then((data) => {
      dispatch(update_user_state({
        user_data: data.data
      }));
      return data.data
    }).catch(function (error) {
      clearToken();
      throw error
    });
  }, [dispatch, clearToken])

  return {
    refreshCurrentUser,
    user_data,
    user_id,
  };
}
